import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  reports: {
    padding: '1rem',
    display: 'flex',
    flexDirection: 'column'
  },
  reportRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '.5rem',
    padding: '4px',
    borderRadius: 4,
    transition: 'background-color 0.15s ease-in-out',
    '&:nth-of-type(odd)': {
      backgroundColor: '#f0f2f9ff'
    },
    '&:hover': {
      backgroundColor: '#E0DDDD'
    }
  },
  reportRowLast: {
    marginBottom: 0
  }
}))

export default useStyles
